import { pBtn, pBtnSmall } from "components/main.styled";
import styled from "styled-components";

export const MediaSectionContainer = styled.div`

    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start; 

`

export const MediaTitle = styled.div`
    margin-top: 10px;
    color: var(--lightThemeFontColor);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`

export const SortButtonsWrap = styled.div`
    height: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start; 
`

export const SortButton = styled(pBtnSmall)`
    background-color: white;
    color: grey;   
    box-shadow: 0px 0px 5px #ccc;
    transition: background-color 0.3s;

    &:hover{
        background-color: #e1e1e1;
    } 
`

export const SearchWrap = styled.div`
    width: ${props => props.extendWidth ? '350px': '45px'};
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 10px;
    background-color: white;
    border-radius: ${props => props.extendWidth ? '40px': '25px'};
    box-shadow: 0px 0px 5px #ccc;
    padding: 5px 5px;
    color: var(--lightThemeFontColor);
    transition: all 0.6s;  
    /* if focus change border */
    &:focus-within{
        box-shadow: 0px 0px 5px rgb(150,150,150);
    }
    @media (max-width: 768px) {
        width: ${props => props.extendWidth ? '170px': '45px'};
    }

`
export const  StyledSearchInput = styled.input`
    border: none;
    outline: none;
    width: ${props => props.extendWidth ? '100%': '0px'};
    height: 100%;
    background-color: transparent;
    color: var(--lightThemeFontColor);
    margin-left: 10px;
`
export const MediaControls = styled.div`

    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: 10px;
`

export const SearchBtn = styled.button`
    cursor: pointer;
    color: #ffffff;
    height: 100%;
    padding-left: 5px;
    padding-right: 5px;
    outline: none;
    border: none;
    background-color: #aaaaaaff;
    border-radius: 14px; 
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    width: 50px;
    &:hover{
        background-color: green;
        color: white;
    }

`

export const MediaFeed = styled.div`

    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: ${props => props.viewDirection };
    align-items: flex-start;
    justify-content: flex-start; 

    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 10px;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1; 
    }
    &::-webkit-scrollbar-thumb {
        background: #888; 
    }

`

export const MediaUpdateModal = styled.div` 
    position: relative;
    width: 500px;
    height: fit-content;
    max-height: 600px;

    overflow-y: scroll;

    /* hide scrollbar */

    /* width */
    ::-webkit-scrollbar {
        width: 0;
    }


    display: flex; 
    flex-direction: column;
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    padding-bottom: 40px;

    h1{
        font-size: 15px;
        color: var(--lightThemeFontColor);
        display: flex;
        align-items: center;
        font-weight: 600;
        margin-bottom: 20px;
    }

    @media (max-width: 768px) {
        width: 100%;
    }

`

export const StyledHeading = styled.h1`

    font-size: 17px;
    font-weight: 300;
    color: var(--lightThemeFontColor);
    text-align: center; 
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
`

export const InputNameWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; 
    border-radius: 15px;
    width: fit-content;
    height: 40px; 
`
export const InputNameWrapChild = styled.div`
    background-color: #e9e9e9d0;
    border-radius: 15px 0px 0px 15px;
    display: flex;
    width: 100%;
    color: var(--lightThemeFontColor);
    padding-left: 15px;
    height: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`

export const SelectFileBtn = styled.label`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: 40px;
    padding: 10px 15px;
    border: none;
    border-radius: 0px 15px 15px 0px; 
    color: var(--lightThemeFontColor);
    cursor: pointer;
    outline: none;
    font-size: 14px;
    background-color: #e4e4e4;

    svg{
        font-size: 20px;
        margin-right: 10px;
    }

    span{
        // keep the text from breaking to a new line
        white-space: nowrap;
        font-size: 13px;
    }

`

export const StyledTextInput = styled.input`
    width: 100%;
    background-color: aliceblue;
    width: 100%;
    height: 50px;
    border: none;
    outline: none; 
    margin-right: 10px;
    padding: 0 15px;
    border-radius: 16px;
    border: 3px solid transparent;
    transition: all 0.3s ease-in-out;

    &:focus{
        border: 3px solid #51CBEE;
    }

    &::placeholder{
        color: var(--lightThemeFontColor);
        opacity: 0.7;
        font-size: 14px;
    }
` 

export const UploadModalContainer = styled.div`
    position: relative;
    background-color: white;
    border-radius: 10px;
    width: 500px;
    min-height: 350px;
    height: fit-content;
    max-height: 450px;
    overflow-y: scroll; 
    &::-webkit-scrollbar {
        width: 0;
    }  
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px;

    @media (max-width: 768px) {
        width: 100%; 
        border-radius: 0px;
        padding: 10px;
    }
`

export const MediaFeedContainer = styled.div`
    margin-top: 10px; 
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    gap: 10px; 
    overflow-y: auto;
    padding: 10px 5px;
    align-content: flex-start;

    &::-webkit-scrollbar {
        width: 0px;
    }

    &::-webkit-scrollbar-thumb { 
        border-radius: 0px;
    }

    @media (max-width: 768px) {
        // need help here
        align-items: center;
        margin-bottom: 10px;
        justify-content: space-around;
        row-gap: 10px; 
    }

`

export const LoadMoreMediaBtn = styled(pBtn)`
   
    background-color: var(--themeColor);
    color: white;

`

export const StyledSubmitButton = styled(pBtn)`
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};

    width: 100px;
    height: 40px; 
    background-color: ${props => props.canSubmit ? 'var(--themeColor)' : 'grey'};
    color: ${props => props.canSubmit ? 'white' : '#e1e1e1'};
    transition: all 0.3s ease-in-out;
    &:hover{
        background-color: #878787;
    }
`